import { ParsedUrlQuery, ParsedUrlQueryInput } from 'querystring';

import { BankInstallmentsViewModel } from '@api/index';
import { FILTERS_QUERY_PARAMS } from '@constants/constants';

import { ListingMetaViewModel } from './types';

export const getPaginationUrlLinksForGoogleRobots = (
  meta: ListingMetaViewModel
) => {
  const nextVisitedLinks = [];
  /* const canonicalPath =
    window.location.href + '&rel=canonical&sayfa=' + meta.currentPage;
  nextVisitedLinks.push(canonicalPath); */

  if (meta.hasNextPage) {
    const nextPath =
      window.location.href + '&rel=next&sayfa=' + (meta.currentPage + 1);
    nextVisitedLinks.push(nextPath);
  }
  if (meta.currentPage > 1) {
    const prevPath =
      window.location.href + '&rel=prev&sayfa=' + (meta.currentPage - 1);
    nextVisitedLinks.push(prevPath);
  }

  return nextVisitedLinks;
};

export const getInstallmentStatus = (
  bankInstallments: Array<BankInstallmentsViewModel>
) => {
  let count = 0;
  if (!bankInstallments || bankInstallments?.length === 0) return count;
  for (const item of bankInstallments) {
    for (const subItem of item.installments) {
      count = count + subItem.totalPrice;
    }
  }
  return count;
};

export const getCurrentPageNumber = (
  queryPage: string | string[] | undefined
) => {
  return Number(queryPage ?? 1);
};

export const getFormattedDate = (query: ParsedUrlQuery) => {
  if (!query) {
    return [];
  }

  const { date } = query;

  if (Array.isArray(date)) {
    return date;
  }

  if (typeof date === 'string') {
    return date.split(',');
  }

  return [];
};

export const isEmptyFilters = (query: ParsedUrlQueryInput) => {
  let isEmpty = true;
  for (const item of FILTERS_QUERY_PARAMS) {
    if (item in query) {
      isEmpty = false;
    }
  }
  return isEmpty;
};

export function paramsToObject(entries: IterableIterator<[string, string]>) {
  const result: Record<string, any> = {};
  for (const [key, value] of entries) {
    if (value.includes(',')) {
      result[key] = value.split(',')?.map((v) => v.trim());
    } else {
      result[key] = value;
    }
  }
  return result;
}

export const resetWrapperBorder = (removeBorder?: boolean) => {
  return removeBorder ? { border: 'none' } : {};
};

export const calculateNights = (
  departureDate: string,
  arrivalDate: string
): number => {
  const departure = new Date(departureDate);
  const arrival = new Date(arrivalDate);

  const diffInMilliseconds = arrival.getTime() - departure.getTime();

  const nights = diffInMilliseconds / (1000 * 60 * 60 * 24);

  return nights;
};
